export class Teams {
  constructor (
    public teams: any[],
  ) {}

  setValue (data) {
    this.teams = data ;
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/teams.ts